export default __webpack_public_path__ + "static/media/kwikswap-rocket-falcon-launchpad.62523ef3.png";